import { mountRaceList } from './utils/mount-race-list.js';
import { FEDERAL_URL } from './constants.js';

const key_congressional_races = [
  1, 3, 6, 11, 13, 21, 22, 26, 27, 40, 41, 45, 47, 48,
];

mountRaceList('ca-key-cd-races', FEDERAL_URL, {
  filter: { offices: ['H'], seats: key_congressional_races, sort: 'seat' },
  component: 'result',
  captionField: 'jurisdiction',
}).catch(console.error);
